<template>
  <b-field :label="label" :horizontal="horizontal">
    <div class="radio-button-container">
      <b-radio-button v-if="includeZero"
        size="is-small"
        :value="valueGetter(value)"
        @input="(v) => $emit('input', v)"
        :native-value="0"
        :type="buttonTypes[0]">
        <span>{{levelLabels[0]}}</span>
      </b-radio-button>
      <b-radio-button v-for="index in levelLabels.length - 1"
        size="is-small"
        :key="index"
        :value="valueGetter(value)"
        @input="(v) => $emit('input', v)"
        :native-value="index"
        :type="buttonTypes[index]">
        <span>{{levelLabels[index]}}</span>
      </b-radio-button>
    </div>
  </b-field>
</template>

<script>
export default {
  props: {
    label: String,
    value: [Number, Object],
    horizontal: {
      type: Boolean,
      default: false,
    },
    includeZero: {
      type: Boolean,
      default: false,
    },
    levelLabels: {
      type: Array,
      default: () => ([
        'None',
        'Novice',
        'Experienced',
        'Very good',
        'Proficient',
      ]),
    },
    valueGetter: {
      type: Function,
      default: v => v,
    },
    buttonTypes: {
      type: Array,
      default: () => ([
        'is-dark',
        'is-danger',
        'is-warning',
        'is-info',
        'is-success',
      ]),
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-button-container {
  flex-direction: row;
  display: flex;
}

/deep/ .field-label {
  flex-grow: 5
}
</style>
